export function OrDivider() {
    return (
        <div className="mt-3 mb-2 text-center text-muted-foreground flex gap-4 justify-between items-center">
            <div className="w-full h-px bg-muted" />
            <span>or</span>
            <div className="w-full h-px bg-muted" />
        </div>
    )
}
